export const getPosts = state => state.posts;
